export default __webpack_public_path__ + "static/media/crew-1.fa9babe9.png";